export default class SubscriptionStats {
  public accountsCount: number = 0;
  public locationsCount: number = 0;
  public serviceProvidersCount: number = 0;
}
